var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 3.66797C3.66699 3.66797 0.916992 11.0013 0.916992 11.0013C0.916992 11.0013 3.66699 18.3346 11.0003 18.3346C18.3337 18.3346 21.0837 11.0013 21.0837 11.0013C21.0837 11.0013 18.3337 3.66797 11.0003 3.66797ZM11.0003 5.5013C15.8367 5.5013 18.2829 9.4128 19.0749 10.9977C18.282 12.5716 15.8174 16.5013 11.0003 16.5013C6.16399 16.5013 3.71778 12.5898 2.92578 11.0049C3.71961 9.43097 6.18324 5.5013 11.0003 5.5013ZM11.0003 7.33464C8.97541 7.33464 7.33366 8.97639 7.33366 11.0013C7.33366 13.0262 8.97541 14.668 11.0003 14.668C13.0252 14.668 14.667 13.0262 14.667 11.0013C14.667 8.97639 13.0252 7.33464 11.0003 7.33464ZM11.0003 9.16797C12.0132 9.16797 12.8337 9.98839 12.8337 11.0013C12.8337 12.0142 12.0132 12.8346 11.0003 12.8346C9.98741 12.8346 9.16699 12.0142 9.16699 11.0013C9.16699 9.98839 9.98741 9.16797 11.0003 9.16797Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevimg);
export default __webpack_public_path__ + "static/media/previmg.b764786aedc134daf909469e5acf882c.svg";
export { ForwardRef as ReactComponent };